/**
 * Created by ganlu on 08/11/2016.
 */
export default () => {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.pwCheck;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    var v = elem.val() === $(firstPassword).val();
                    ctrl.$setValidity('pwcheck', v);
                });
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/common/form/pwcheck.directive.js